import React from 'react';
import Component from '@vfuk/core-calendar-picker';
const CalendarPicker = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CalendarPicker;
